import type {ReactNode} from "react";
import {NavItem, NavSection} from "~/components/header/collapsed-header/subnavigation/common";
import {Accordion, AccordionItem, AccordionTrigger, AccordionContent} from "~/components/ui/accordion";
import {useTranslation} from "react-i18next";

export function FleetSubSection({ close}: {close: () => void}) {
    const { t } = useTranslation("common");
    const comingSoon = t("subnav.products.coming_soon");

    return <NavSection value="fleet" label={t("nav.fleet")}>
        <Accordion type="multiple" defaultValue={["fleet-solutions"]}>
            <FleetSubSectionContainer value="fleet-solutions" label={t("subnav.fleet.col_fleet_solutions")}>
                <NavItem label={t("subnav.fleet.all_solutions")} to="/fleet" onClick={close} />
            </FleetSubSectionContainer>
            <FleetSubSectionContainer value="industry-solutions" label={t("subnav.fleet.col_industries")}>
                <NavItem label={t("subnav.fleet.industry_list.trade_services")} to="/fleet" onClick={close} />
                <NavItem label={t("subnav.fleet.industry_list.delivery_logistics")} to="/fleet" onClick={close} />
                <NavItem label={t("subnav.fleet.industry_list.rentals")} to="/fleet/rental" onClick={close} />
                <NavItem label={t("subnav.fleet.industry_list.turo_hosts")} to="/fleet/turo" onClick={close} />
                <NavItem label={t("subnav.fleet.industry_list.charitable")} to="/fleet/non-profit" onClick={close} />
                <NavItem label={t("subnav.fleet.industry_list.government")} to="/fleet/municipal" onClick={close} />
            </FleetSubSectionContainer>
            <FleetSubSectionContainer value="fleet-products" label={t("subnav.fleet.col_platform")}>
                <NavItem label={t("subnav.products.drive.name")} to="/fleet/products/drive" onClick={close} />
                <NavItem label={t("subnav.products.view.name")} to="/products/view" badge={comingSoon} onClick={close} />
                <NavItem label={t("subnav.products.go.name")} to="/products/go" onClick={close} />
            </FleetSubSectionContainer>
        </Accordion>
    </NavSection>
}

function FleetSubSectionContainer({
                             value, label, children,
                         }: {
    value: string; label: string; children: ReactNode;
}) {
    return (
        <AccordionItem value={value} className="fleet:bg-transparent border-none">
            <AccordionTrigger data-sid={`nav-collapsed-subtrigger:fleet:${value}`} className="py-3 pr-4 pl-10">
                {label}
            </AccordionTrigger>
            <AccordionContent className="p-0">
                {children}
            </AccordionContent>
        </AccordionItem>
    );
}
